define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/selector.js
// module id = 3
// module chunks = 0